export default () => ({
  SET_INVALID_ITEM_IDS: (state, payload) => (state.invalidItemIds = payload),

  SET_GETTING_OTA_DATA_STATUS: (state, data) => (state.gettingOtaData = data),

  SET_ACTIVE_ITEMS_COUNT: (state, count) => (state.activeItemsCount = count),

  ADD_ACTIVE_ITEMS_COUNT: (state, count) => (state.activeItemsCount += count)
})
